import {gql} from "@apollo/client";

export const NOTIFICATION_PAGE_SIZE = 20;

export const GET_NOTIFICATION_CATEGORIES = gql`
  query GetNotificationCategories {
    notificationCategories
  }
`;

export const GET_NOTIFICATION_CENTER = gql`
  query GetNotificationCenter($category: String!, $limit: Int, $cursor: Int) {
    notificationCenter(category: $category, limit: $limit, cursor: $cursor)
  }
`;

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($id: Int!) {
    markNotificationAsRead(id: $id)
  }
`;

export const MARK_NOTIFICATIONS_AS_SEEN = gql`
  mutation MarkNotificationsAsSeen($category: String!) {
    markNotificationsAsSeen(category: $category)
  }
`;

export const GET_UNSEEN_NOTIFICATION_COUNTS = gql`
  query GetUnseenNotificationCounts {
    unseenNotificationCounts
  }
`;

export const SUBSCRIBE_TO_STORED_NOTIFICATIONS = gql`
  subscription SubscribeToStoredNotifications($userId: Int!) {
    subscribeToStoredNotifications(userId: $userId)
  }
`;
